module.exports = __webpack_public_path__ + "static/media/img_internal_mobility_01.d690718c.png";